import {
  defaultTagBadgeColour,
  resolveTagBadgeColourSwatch,
  tagBadgeColourOptions,
} from './tagBadgeColours';
import type { ProjectBadgeColor } from '@flowqa/shared';

export const defaultProjectBadgeColor: ProjectBadgeColor = defaultTagBadgeColour;
export const projectBadgeCharsMaxLength = 2;

export const projectBadgeColorOptions: Array<{ value: ProjectBadgeColor; swatch: string }> =
  tagBadgeColourOptions;

const stripBadgeChars = (value: string): string =>
  value
    .replace(/[^a-z0-9]/gi, '')
    .toUpperCase()
    .slice(0, projectBadgeCharsMaxLength);

const deriveBadgeCharsFromWords = (value: string): string =>
  (value.match(/[a-z0-9]+/gi) ?? [])
    .slice(0, projectBadgeCharsMaxLength)
    .map((word) => word[0])
    .join('')
    .toUpperCase();

export const deriveProjectBadgeChars = (name: string): string => {
  const trimmed = name.trim();
  if (trimmed.length === 0) return 'P';

  const normalized = deriveBadgeCharsFromWords(trimmed);
  return normalized || 'P';
};

export const normalizeProjectBadgeChars = (value: string): string => stripBadgeChars(value);

export const getRandomProjectBadgeColor = (): ProjectBadgeColor => {
  const randomIndex = Math.floor(Math.random() * projectBadgeColorOptions.length);
  return projectBadgeColorOptions[randomIndex]?.value ?? defaultProjectBadgeColor;
};

export const resolveProjectBadgeSwatch = (color: ProjectBadgeColor): string =>
  resolveTagBadgeColourSwatch(color);
